import { render } from "./VideoBgSelectorPage.vue?vue&type=template&id=9fb30d64&scoped=true"
import script from "./VideoBgSelectorPage.vue?vue&type=script&lang=js"
export * from "./VideoBgSelectorPage.vue?vue&type=script&lang=js"

import "./VideoBgSelectorPage.vue?vue&type=style&index=0&id=9fb30d64&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb30d64"]])

export default __exports__